import { decode as decodeHtmlEntitiesLib } from 'html-entities';

function toSafeString(value: unknown): string {
  return typeof value === 'string' ? value : value ? String(value) : '';
}

/**
 * Decode common HTML entities into their actual characters (e.g. &#039; → ').
 * Does not strip or alter HTML tags — suitable before renderers that expect HTML structure (e.g. react-pdf-html).
 */
export function decodeHtmlEntities(value: unknown): string {
  const str = toSafeString(value);
  if (!str) return '';

  try {
    return decodeHtmlEntitiesLib(str);
  } catch {
    return str;
  }
}
